var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('breadcrumbs',{attrs:{"titulo":"Configurações","descricao":"Atualização de senha"}}),_c('v-layout',{staticClass:"main full"},[_c('v-flex',[_c('v-layout',{staticClass:"content-body overflow-y-auto",attrs:{"row":""}},[_c('Configuracao')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }